import { __decorate } from "tslib";
import lang from '@blade-sxp/portrait-management/lang/index';
import PortraitLibraryTable from '@blade-sxp/portrait-management/pages/components/portrait-library-table.vue';
import VehicleLibraryTable from '@blade-sxp/portrait-management/pages/components/vehicle-library-table.vue';
import BodyLibraryTable from '@blade-sxp/portrait-management/pages/components/body-library-table.vue';
import CreateLibrary from '@blade-sxp/portrait-management/pages/components/create-library.vue';
import InputSearch from '@blade-sxp/portrait-management/components/input-search.vue';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { addPortraitLib, queryPortraitLibPageList, updatePortraitLib } from '@blade-sxp/portrait-management/api/porttaitLib';
import { addVehicleLib, queryVehicleLibPageList, updateVehicleLib } from '@blade-sxp/portrait-management/api/vehicleLib';
import { addBodyLibrary, updateBodyLibrary, queryBodyLibPageList } from '@blade-sxp/portrait-management/api/body';
import { PortraitManagementDataModule } from '@blade-sxp/portrait-management/store/index';
import { cloneDeep } from 'lodash';
import { LoginModule } from '@blade/common/store/login';
import { SYSTEMCODE } from '@blade/common/constants/code';
const Webapi = {
    addPortraitLib,
    queryPortraitLibPageList,
    updatePortraitLib,
    addVehicleLib,
    queryVehicleLibPageList,
    updateVehicleLib,
    addBodyLibrary,
    updateBodyLibrary,
    queryBodyLibPageList,
};
let default_1 = class default_1 extends Vue {
    tabKeyPortrait = 'portrait';
    tabKeyBody = 'body';
    tabKeyVehicle = 'vehicle';
    showBtns = false; // 2026.2.5屏蔽新建库按钮以及table action项
    permissons = [];
    permissionPortraitLibrary = false;
    permissionVehicleLibrary = false;
    permissionBodyLibrary = false;
    // 激活的标签
    activeTab = PortraitManagementDataModule.portraitLibActiveTab || this.tabKeyPortrait;
    // 标签列表
    tabList = [];
    // 表单
    queryForm = {
        portrait: {
            keyword: '',
        },
        vehicle: {
            keyword: '',
        },
        body: {
            keyword: '',
        },
    };
    // 分页
    paginationParams = {
        portrait: {
            page: 1,
            size: 10,
            total: 0,
        },
        vehicle: {
            page: 1,
            size: 10,
            total: 0,
        },
        body: {
            page: 1,
            size: 10,
            total: 0,
        },
    };
    // 最后一次的分页数据
    lastPaginationParams = null;
    // 数据
    tableData = {
        portrait: [],
        vehicle: [],
        body: [],
    };
    // 弹出框
    createLib = {
        visible: false,
        title: '',
        placeholder: '',
    };
    // 当前操作的库表单
    operateLibForm = null;
    loading = false;
    submitting = false;
    // 是否包含ID
    get currentFormHasId() {
        if (!this.operateLibForm)
            return false;
        return !!this.operateLibForm.libId;
    }
    paginationParamsChange() {
        // 加载策略 页码和页面尺寸发生变化时重新加载列表
        if (!this.lastPaginationParams)
            return this.getList();
        let curr = this.paginationParams[this.activeTab];
        let last = this.lastPaginationParams[this.activeTab];
        if (curr.page !== last.page || curr.size !== last.size)
            this.getList();
    }
    activeTabChange(val) {
        PortraitManagementDataModule.setPortraitLibActiveTab(val);
    }
    findChildByCode(root, code) {
        let children;
        if (!(root instanceof Array)) {
            if (!root)
                return;
            if (root.code === code)
                return root;
            children = root.subPermissions;
        }
        else
            children = root;
        if (!children || children.length < 1)
            return;
        for (const child of children) {
            const permission = this.findChildByCode(child, code);
            if (permission?.code === code)
                return permission;
        }
    }
    created() {
        this.permissons = LoginModule.permissions || [];
        // 获取库管理子权限
        this.permissionPortraitLibrary = this.findChildByCode(this.permissons, SYSTEMCODE.PORTRAIT)?.enable;
        this.permissionVehicleLibrary = this.findChildByCode(this.permissons, SYSTEMCODE.VEHICLE)?.enable;
        this.permissionBodyLibrary = this.findChildByCode(this.permissons, SYSTEMCODE.BODY)?.enable;
        let tabArr = [
            {
                name: this.$t('portraitLibrary'),
                key: this.tabKeyPortrait,
                enable: this.permissionPortraitLibrary,
            },
            {
                name: this.$t('bodyLibrary'),
                key: this.tabKeyBody,
                enable: this.permissionBodyLibrary,
            },
            {
                name: this.$t('vehicleLibrary'),
                key: this.tabKeyVehicle,
                enable: this.permissionVehicleLibrary,
            },
        ];
        this.tabList = tabArr.filter((item) => item.enable);
        this.activeTab = this.activeTab || this.tabList[0].key;
        this.initData();
    }
    // 标签点击事件
    handleTabClick() {
        this.getList();
    }
    // 处理搜索框关键词回车事件
    handlePortraitEnter() { }
    // 打开创建库对话框
    openCreateLibDialog() {
        this.createLib = {
            visible: true,
            title: this.$t((this.currentFormHasId ? 'edit' : 'new') + 'Library').toString(),
            placeholder: this.$t(this.activeTab + 'LibraryNameInputHolder').toString(),
        };
    }
    // 新建库的事件
    handleAdd() {
        this.operateLibForm = {
            name: '',
        };
        this.openCreateLibDialog();
    }
    // 编辑库的事件
    handleEdit(item) {
        this.operateLibForm = cloneDeep(item);
        this.openCreateLibDialog();
    }
    // 初始化数据
    initData() {
        // 表单
        this.queryForm = {
            portrait: {
                keyword: '',
            },
            vehicle: {
                keyword: '',
            },
            body: {
                keyword: '',
            },
        };
        // 分页
        this.paginationParams = {
            portrait: {
                page: 1,
                size: 10,
                total: 0,
            },
            vehicle: {
                page: 1,
                size: 10,
                total: 0,
            },
            body: {
                page: 1,
                size: 10,
                total: 0,
            },
        };
    }
    // 获取数据
    async getList() {
        if (!this.paginationParams)
            return;
        this.loading = true;
        try {
            let keywords = this.queryForm[this.activeTab].keyword;
            let result;
            switch (this.activeTab) {
                case this.tabKeyPortrait:
                    result = await Webapi.queryPortraitLibPageList({
                        ...this.paginationParams[this.activeTab],
                        keywords,
                    });
                    break;
                case this.tabKeyBody:
                    result = await Webapi.queryBodyLibPageList({
                        ...this.paginationParams[this.activeTab],
                        keywords,
                    });
                    break;
                case this.tabKeyVehicle:
                    result = await Webapi.queryVehicleLibPageList({
                        ...this.paginationParams[this.activeTab],
                        keywords,
                    });
                    break;
                default:
                    break;
            }
            this.paginationParams[this.activeTab].total = result.total;
            this.tableData[this.activeTab] = result.list;
            this.lastPaginationParams = cloneDeep(this.paginationParams);
        }
        catch (error) {
            console.log('getList error', error);
        }
        this.loading = false;
    }
    // 刷新列表
    refreshList() {
        if (!this.paginationParams)
            return;
        this.tableData[this.activeTab] = [];
        if (this.paginationParams[this.activeTab].page !== 1)
            this.paginationParams[this.activeTab].page = 1;
        else
            this.getList();
    }
    // 提交更新
    async confirmFunc(form) {
        if (this.submitting)
            return;
        this.submitting = true;
        try {
            if (form.libId) {
                // 编辑
                if (this.activeTab === this.tabKeyPortrait)
                    await Webapi.updatePortraitLib(form);
                else if (this.activeTab === this.tabKeyVehicle)
                    await Webapi.updateVehicleLib(form);
                else if (this.activeTab === this.tabKeyBody)
                    await Webapi.updateBodyLibrary(form);
                this.$message({
                    customClass: 'success-message',
                    message: this.$t('editSuccessfully').toString(),
                    type: 'success',
                    showClose: true,
                });
            }
            else {
                // 新增
                if (this.activeTab === this.tabKeyPortrait)
                    await Webapi.addPortraitLib(form);
                else if (this.activeTab === this.tabKeyVehicle)
                    await Webapi.addVehicleLib(form);
                else if (this.activeTab === this.tabKeyBody)
                    await Webapi.addBodyLibrary(form);
                this.$message({
                    customClass: 'success-message',
                    message: this.$t('createSuccessfully').toString(),
                    type: 'success',
                    showClose: true,
                });
            }
            this.refreshList();
        }
        catch (error) {
            console.log('confirmFunc error', error);
        }
        this.submitting = false;
    }
};
__decorate([
    Watch('paginationParams', { deep: true })
], default_1.prototype, "paginationParamsChange", null);
__decorate([
    Watch('activeTab')
], default_1.prototype, "activeTabChange", null);
default_1 = __decorate([
    Component({
        components: {
            PortraitLibraryTable,
            VehicleLibraryTable,
            CreateLibrary,
            InputSearch,
            BodyLibraryTable,
        },
        i18n: {
            messages: lang,
        },
    })
], default_1);
export default default_1;
